import Q3DataStructure from "./q3-data-structure";
import initLayers from "./init-layers";

function initData(data = {}, noControls) {

    if (!data.assets || !data.setups) {//or anything... proper way to check new demo ?
        data = new Q3DataStructure();
    }

    initLayers(data);

    return new Q3DataStructure().deserialize(data, noControls);
}

export default initData;
export { initData };